import { ListView, ListViewColumnType, initListView } from '../../UI/view/list-view';
import { DataSource } from '../../UI/view/data-source';
import { getUpcomingOrdersForLocation } from '../../../services/requests/orders/orders-requests';

// Legacy Shipping Location Status grid (gvFutureDeliveriesByLocation): upcoming
// placed orders for the current order's shipping location. Scoped to the loaded
// order via requestArgs (orderTypeId + shippingLocationId → request spreads them).
export const upcomingOrdersForLocationDataSource = {
  name: 'upcomingOrdersForLocation',
  pk: 'id',
  request: getUpcomingOrdersForLocation,
  // Scoped to the live form's order type + shipping location (edit + create).
  requestArgs: (_state: any, watch?: any) => [watch?.('orderTypeId'), watch?.('shippingLocationId')],
  watchFields: ['orderTypeId', 'shippingLocationId'],
} as DataSource;

export const upcomingOrdersForLocationListView = {
  hideGlobalFilter: true,
  columns: [
    { Header: 'Customer', accessor: 'customerName' },
    { Header: 'Destination City', accessor: 'destinationCity' },
    { Header: 'Destination State', accessor: 'destinationState' },
    { Header: 'Date Requested', accessor: 'dateRequested', type: ListViewColumnType.date, defaultSort: true },
    {
      Header: 'Order #',
      accessor: 'orderNumber',
      type: ListViewColumnType.link,
      newLink: true,
      linkPath: ({ row }: any) => `/orders/edit/${row?.original?.id}`,
    },
  ],
} as ListView;

export const OrderLocationStatusListView = initListView(upcomingOrdersForLocationListView, upcomingOrdersForLocationDataSource);
